import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../lib/api';
import { useAuth } from '../hooks/useAuth';
import { Badge } from '../components/ui';

export function TopBar() {
  const { account, logout } = useAuth();
  const navigate = useNavigate();
  const [resent, setResent] = useState(false);

  return (
    <header className="topbar">
      <div className="topbar-title">{account?.company ?? account?.name ?? 'Dashboard'}</div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        {/* An unverified account can browse but can't mint keys — say so here
            rather than only failing at the point of action. */}
        {account && !account.email_verified && (
          <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <Badge tone="warning">Email unverified</Badge>
            <button
              className="btn btn-sm"
              disabled={resent}
              onClick={async () => {
                await auth.resendVerification().catch(() => undefined);
                setResent(true);
              }}
            >
              {resent ? 'Email sent' : 'Resend email'}
            </button>
          </span>
        )}

        <span className="muted">{account?.email}</span>

        <button
          className="btn btn-sm"
          onClick={async () => {
            await logout();
            navigate('/login');
          }}
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
